import React from "react";

const DIGITS = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];
const CODE_LENGTH = 6;

export default function PrivateTournamentCodeModal({
  title,
  text,
  code,
  error,
  loading = false,
  deleteLabel,
  confirmLabel,
  cancelLabel,
  onDigit,
  onDelete,
  onConfirm,
  onCancel,
}) {
  const safeCode = String(code || "").slice(0, CODE_LENGTH);
  const canConfirm = safeCode.length === CODE_LENGTH && !loading;
  const maskedCode = Array.from({ length: CODE_LENGTH }, (_, index) =>
    index < safeCode.length ? "●" : "○"
  ).join("");

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 10000,
        background: "rgba(0,0,0,0.68)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding:
          "calc(24px + env(safe-area-inset-top)) 18px calc(24px + env(safe-area-inset-bottom))",
        boxSizing: "border-box",
      }}
      onClick={() => {
        if (!loading) onCancel?.();
      }}
    >
      <div
        style={{
          width: "min(440px, 100%)",
          borderRadius: 24,
          padding: 22,
          boxSizing: "border-box",
          border: "1px solid rgba(255,255,255,0.22)",
          background:
            "linear-gradient(145deg, rgba(22,18,78,0.98) 0%, rgba(43,20,96,0.98) 100%)",
          boxShadow:
            "0 26px 70px rgba(0,0,0,0.46), 0 0 28px rgba(255,0,127,0.18)",
          color: "#fff",
          fontFamily:
            "'Cooper Hewitt', system-ui, -apple-system, BlinkMacSystemFont, Arial, sans-serif",
        }}
        onClick={(event) => event.stopPropagation()}
      >
        <h2
          style={{
            margin: 0,
            fontSize: 26,
            textAlign: "center",
            textTransform: "uppercase",
            letterSpacing: 0.6,
          }}
        >
          {title}
        </h2>
        <p
          style={{
            margin: "8px 0 18px",
            color: "rgba(255,255,255,0.74)",
            lineHeight: 1.35,
            textAlign: "center",
            fontWeight: 800,
          }}
        >
          {text}
        </p>

        <div
          aria-label="Turniercode"
          style={{
            height: 58,
            borderRadius: 16,
            border: "1px solid rgba(255,255,255,0.24)",
            background: "rgba(255,255,255,0.08)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            letterSpacing: 7,
            fontSize: 24,
            fontWeight: 1000,
            marginBottom: 16,
          }}
        >
          {maskedCode}
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 10,
          }}
        >
          {DIGITS.map((digit) => (
            <button
              key={digit}
              type="button"
              disabled={loading || safeCode.length >= CODE_LENGTH}
              onClick={() => onDigit?.(digit)}
              style={{
                height: 54,
                borderRadius: 16,
                border: "1px solid rgba(255,255,255,0.22)",
                background: "rgba(255,255,255,0.10)",
                color: "#fff",
                fontSize: 22,
                fontWeight: 1000,
                cursor: loading || safeCode.length >= CODE_LENGTH ? "not-allowed" : "pointer",
                opacity: loading || safeCode.length >= CODE_LENGTH ? 0.72 : 1,
              }}
            >
              {digit}
            </button>
          ))}
        </div>

        {error && (
          <div
            style={{
              marginTop: 14,
              padding: "10px 12px",
              borderRadius: 14,
              border: "1px solid rgba(255,80,90,0.45)",
              background: "rgba(255,59,48,0.16)",
              color: "#ffd7d7",
              fontWeight: 900,
              textAlign: "center",
              lineHeight: 1.35,
            }}
          >
            {error}
          </div>
        )}

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: 10,
            marginTop: 18,
          }}
        >
          <button
            type="button"
            disabled={loading}
            onClick={onDelete}
            style={{
              height: 50,
              borderRadius: 16,
              border: "1px solid rgba(255,255,255,0.22)",
              background: "rgba(255,255,255,0.10)",
              color: "#fff",
              fontSize: 12,
              fontWeight: 1000,
              letterSpacing: 0.2,
              textTransform: "uppercase",
              cursor: loading ? "wait" : "pointer",
            }}
          >
            {deleteLabel}
          </button>
          <button
            type="button"
            disabled={!canConfirm}
            onClick={onConfirm}
            style={{
              height: 50,
              borderRadius: 16,
              border: "1px solid rgba(255,255,255,0.26)",
              background: canConfirm
                ? "linear-gradient(135deg, #ff007f 0%, #8a2bff 100%)"
                : "rgba(255,255,255,0.12)",
              color: "#fff",
              fontSize: 12,
              fontWeight: 1000,
              letterSpacing: 0.2,
              textTransform: "uppercase",
              cursor: canConfirm ? "pointer" : "not-allowed",
              opacity: canConfirm ? 1 : 0.65,
            }}
          >
            {confirmLabel}
          </button>
          <button
            type="button"
            disabled={loading}
            onClick={onCancel}
            style={{
              height: 50,
              borderRadius: 16,
              border: "1px solid rgba(255,255,255,0.22)",
              background: "rgba(255,255,255,0.10)",
              color: "#fff",
              fontSize: 12,
              fontWeight: 1000,
              letterSpacing: 0.2,
              textTransform: "uppercase",
              cursor: loading ? "wait" : "pointer",
            }}
          >
            {cancelLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
